/**
 * @generated SignedSource<<a2482649a044f855ef5ab1cb702c801a>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CreateUserInput = {
  auth0Id: string;
  email: string;
  firstName?: string | null | undefined;
  imageUrl?: string | null | undefined;
  lastName?: string | null | undefined;
};
export type UserSyncMutation$variables = {
  input: CreateUserInput;
};
export type UserSyncMutation$data = {
  readonly createUser: {
    readonly __typename: "User";
  };
};
export type UserSyncMutation = {
  response: UserSyncMutation$data;
  variables: UserSyncMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UserSyncMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "createUser",
        "plural": false,
        "selections": [
          (v2/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "MutationRoot",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "UserSyncMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "createUser",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "05cc2db3bee2a35e4950cba25df32ad9",
    "id": null,
    "metadata": {},
    "name": "UserSyncMutation",
    "operationKind": "mutation",
    "text": "mutation UserSyncMutation(\n  $input: CreateUserInput!\n) {\n  createUser(input: $input) {\n    __typename\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "56ee5fb3f80c66ab4f2278d05f808b5c";

export default node;
